import { render, staticRenderFns } from "./IntentEditor.vue?vue&type=template&id=04d82524&scoped=true"
import script from "./IntentEditor.vue?vue&type=script&lang=js"
export * from "./IntentEditor.vue?vue&type=script&lang=js"
import style0 from "./IntentEditor.vue?vue&type=style&index=0&id=04d82524&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d82524",
  null
  
)

export default component.exports